<template>
  <interview-layout :touch-and-validate="touch-and-validate">
    <div class="">
      <h1 class="px-4 pb-3 fade-in-up-enter-active animation-slowest max-100 text-primary">SNN subsidie</h1>
      
      <div class="d-flex flex-column flex-lg-row justify-content-center">
        <base-card inner-class="container-narrow w-100" color="alternate" :outer-padding="true">
          <base-form @submit="onSubmit">

            <!-- EERSTE VRAAG: Hulp bij SNN subsidies -->
            <base-input
              type="radiobuttons" 
              :options="yesNo"
              name="hulpSnnSubsidies"
              v-model:value="lead.financing.snnSubsidyVenV.hulpSnnSubsidies" 
              :validator="v$.financing.snnSubsidyVenV.hulpSnnSubsidies">
              Wilt u hulp bij het aanvragen van eventuele SNN subsidies?
            </base-input>

            <!-- Alles tonen alleen als hulpSnnSubsidies = true -->
            <div v-if="lead.financing.snnSubsidyVenV.hulpSnnSubsidies === true">

              <!-- section SNN 10000 euro -->
              <div class="fade-in-up-enter-active animation-slowest delay-200" v-if="lead.property.InVersterkingsprogramma === false">
                <h6 class="pb-3 mt-5 max-100">Subsidie Verduurzaming en Verbetering Groningen – &euro;10.000</h6>

                <base-card class="mb-3" inner-class="small" color="secondary">
                  <h6 class="mb-2">Voorwaarden voor €10.000 subsidie</h6>
                  <checkmark-item class="mb-2" icon="check-circle-fill" :icon-color="!lead.property.InVersterkingsprogramma ? 'success' : 'warning'">
                    <strong class="fw-600">Niet in versterkingsprogramma:</strong> {{ !lead.property.InVersterkingsprogramma ? 'Uw woning valt niet binnen het versterkingsprogramma van NCG.' : 'En valt uw woning niet binnen het versterkingsprogramma van NCG?' }}
                  </checkmark-item>
                  <p class="mb-0">
                    Onder deze voorwaarden komt u waarschijnlijk in aanmerking voor deze subsidie die u kunt besteden aan verduurzamende of verbeterende maatregelen aan uw woning of bijgebouw. Meer informatie vind u op 
                    <a href="https://www.snn.nl/subsidies-voor-particulieren/subsidie-verduurzaming-en-verbetering-groningen-eu-10000" target="_blank">website van het SNN</a>.
                  </p>
                </base-card>

                <base-input
                  type="radiobuttons" 
                  :options="yesNoDontKnow"
                  name="RequestedSnn10k"
                  v-model:value="lead.financing.snnSubsidyVenV.RequestedSnn10k" 
                  :validator="v$.financing.snnSubsidyVenV.RequestedSnn10k">
                  Is er eerder de subsidie Verduurzaming en Verbetering Groningen (&euro;10.000) aangevraagd voor uw woning?
                </base-input>
              </div>

              <!-- section SNN 4000 euro (Waardevermeerderingsregeling) -->
              <div class="fade-in-up-enter-active animation-slowest delay-200">
                <h6 class="pb-3 mt-5 max-100">Subsidie Waardevermeerderingsregeling Groningen – &euro;4.000</h6>

                <!-- Info-dingetje boven de vragen -->
                <base-card class="mb-3" inner-class="small" color="secondary">
                    <h6 class="mb-2">Voorwaarden voor €4.000 subsidie</h6>

                    <checkmark-item class="mb-2" icon="check-circle-fill" icon-color="success">
                        <strong class="fw-600">Aardbevingsschade:</strong> Er is sprake van erkende aardbevingsschade van ten minste €1.000.
                    </checkmark-item>

                    <checkmark-item class="mb-2" icon="check-circle-fill" icon-color="success">
                        <strong class="fw-600">Niet eerder gebruikt:</strong> Er is nog niet eerder gebruikgemaakt van de tijdelijke regeling Waardevermeerdering (van kracht tot 2017).
                    </checkmark-item>
                </base-card>

                <!-- Vraag 1: Heeft aardbevingsschade -->
                <base-input
                  type="radiobuttons" 
                  :options="yesNo"
                  name="HeeftAardbevingsschade"
                  v-model:value="lead.financing.snnSubsidyVenV.snnSubsidy4k.HeeftAardbevingsschade" 
                  :validator="v$.financing.snnSubsidyVenV.snnSubsidy4k.HeeftAardbevingsschade">
                  Bent u woning eigenaar of huurder met erkende aardbevingsschade van ten minste &euro;1.000?
                </base-input>

                <!-- Vraag 2: Niet eerder gebruik gemaakt (alleen als Vraag 1 = Ja) -->
                <base-input
                    v-if="showSnn4kVraag2"
                    type="radiobuttons" 
                    :options="yesNo"
                    name="NietEerderGebruikt"
                    v-model:value="lead.financing.snnSubsidyVenV.snnSubsidy4k.NietEerderGebruikt" 
                    :validator="v$.financing.snnSubsidyVenV.snnSubsidy4k.NietEerderGebruikt">
                    Er is niet eerder gebruikgemaakt van de tijdelijke regeling Waardevermeerdering (van kracht tot 2017).
                </base-input>
              </div>
            </div>
          </base-form>
        </base-card>
      </div>
      
      <button-row class="mt-2 flex-row-reverse">
        <base-button 
          class="ms-auto" 
          icon="bi-arrow-right" 
          @click="onSubmit" 
          :disabled="v$.financing.snnSubsidyVenV.$invalid">
          Volgende
        </base-button>
        <base-button 
          variant="minimal-secondary" 
          icon="bi-arrow-left" 
          icon-position="start" 
          @click="onPrev">
          Terug
        </base-button>
      </button-row>
    </div>
  </interview-layout>
</template>

<script>
  import InterviewLayout from "@/views/layouts/InterviewLayout.vue"
  import BaseCard from '@/components/BaseCard.vue'
  import BaseForm from "@/components/BaseForm.vue"
  import BaseInput from "@/components/BaseInput.vue"
  import BaseButton from "@/components/BaseButton.vue"
  import ButtonRow from "@/components/ButtonRow.vue"
  import CheckmarkItem from "@/components/CheckmarkItem.vue"

  import { useAllStores } from "@/helpers/UseAllStores"
  import { CommonComposable } from "@/helpers/CommonComposable"
  import { FlowService } from "@/services/FlowService"

  export default {
    components: {
      InterviewLayout,
      BaseCard,
      BaseForm,
      BaseInput,
      BaseButton,
      ButtonRow,
      CheckmarkItem
    },
    setup(props, context) {
      return { ...CommonComposable(props, context), ...useAllStores() };
    },
    data() {
      return {
        yesNo: [
          { label: 'Ja', value: true },
              { label: 'Nee', value: false },
        ],
        yesNoDontKnow: [
          { label: 'Ja', value: 'Ja' },
          { label: 'Nee', value: 'Nee' },
            { label: 'Weet ik niet', value: 'Weet ik niet' },

        ]
      };
    },
    computed: {
      showSnn4kVraag2() {
        return this.lead.financing.snnSubsidyVenV.snnSubsidy4k.HeeftAardbevingsschade === true;
      },
      showSnn4kEligible() {
        return (
            this.lead.financing.snnSubsidyVenV.snnSubsidy4k.HeeftAardbevingsschade === true &&
            this.lead.financing.snnSubsidyVenV.snnSubsidy4k.NietEerderGebruikt === true
        );
      },
      showSnn4kNotEligible() {
        return this.lead.financing.snnSubsidyVenV.snnSubsidy4k.HeeftAardbevingsschade === false;
      }
    },
    methods: {
      touchAndValidate() {
        this.v$.financing.snnSubsidyVenV.$touch();
        // snnSubsidy4k alleen touch als hulpSnnSubsidies = true
        if (this.lead.financing.snnSubsidyVenV.hulpSnnSubsidies === true) {
            this.v$.financing.snnSubsidyVenV.snnSubsidy4k.$touch();
        }
        return !this.v$.financing.snnSubsidyVenV.$invalid && !this.v$.financing.snnSubsidyVenV.snnSubsidy4k.$invalid;
      },
      onSubmit() {
        if (this.touchAndValidate()) {
          FlowService.pushNext(this);
        }
      },
      onPrev() {
        FlowService.pushPrev(this);
      }
    },

  }
</script>

<style lang="scss">
</style>